"use client";

import { useQuery } from "@tanstack/react-query";
import { Session } from "next-auth";
import { getCommunitiesToHost } from "../beta/events/create/actions";
import { CreateEventButton } from "../beta/home/_components/CreateEventModal";
import { CommunityIcon, PeopleIcon, TicketIcon } from "./Icons";

import { usePathname, useRouter, useParams } from "next/navigation";
import { useHomePageRenderStore } from "~/state/store";
import { Button } from "~/components/v4/themed/Button";
import { NotificationMenu } from "~/components/notifications-components/client-components/NotificationMenu";
import { api } from "~/utils/api";
import { useEffect } from "react";
import { FaQuestion } from "react-icons/fa6";

export const getCommunitiesToHostQuery = () => {
    return useQuery({
        queryKey: ["communities-to-host"],
        queryFn: async () => {
            return getCommunitiesToHost();
        },
    });
};

export const BottomNavBar = ({ session }: { session?: Session | null }) => {
    const pathname = usePathname();
    const params = useParams();
    const communitySlug = params?.slug || params?.communitySlug;

    const router = useRouter();
    const { data: communitiesToHost, isLoading } = getCommunitiesToHostQuery();
    const { tab, setTab } = useHomePageRenderStore();
    const { data: unreadNotificationsCount } =
        api.notification.getUnreadNotificationsCount.useQuery(undefined, {
            enabled: !!session?.user,
        });

    useEffect(() => {
        if (
            typeof window !== "undefined" &&
            window.Intercom &&
            window.innerWidth < 768
        ) {
            window.Intercom("update", { hide_default_launcher: true });
        }
        return () => {
            if (
                typeof window !== "undefined" &&
                window.Intercom &&
                window.innerWidth < 768
            ) {
                window.Intercom("update", { hide_default_launcher: false });
            }
        };
    }, []);

    const handleNavigate = (selectedTab: typeof tab) => {
        if (pathname !== "/beta/home") {
            router.push("/beta/home");
        }
        setTab(selectedTab);
    };

    return (
        <span className="fixed bottom-0 z-[100] w-full">
            <div className="z-10 flex h-16 w-full flex-row items-center justify-center gap-4 bg-v3-N-600 px-2 md:hidden">
                <Button
                    variant="ghost"
                    className="flex h-[24px] w-[64px] flex-1 items-center justify-center"
                    onClick={() => handleNavigate("events")}
                >
                    <TicketIcon isSelected={tab === "events"} />
                </Button>

                <Button
                    variant="ghost"
                    className="flex h-[24px] w-[64px] flex-1 items-center justify-center"
                    onClick={() => handleNavigate("communities")}
                >
                    <CommunityIcon isSelected={tab === "communities"} />
                </Button>

                <Button
                    variant="ghost"
                    className="flex h-[24px] w-[64px] flex-1 items-center justify-center"
                    onClick={() => handleNavigate("people")}
                >
                    <PeopleIcon isSelected={tab === "people"} />
                </Button>

                <Button
                    variant="ghost"
                    className="flex h-[24px] w-[64px] flex-1 items-center justify-center"
                >
                    <NotificationMenu count={unreadNotificationsCount ?? 0} />
                </Button>

                <Button
                    variant="ghost"
                    className="flex h-[24px] w-[64px] flex-1 items-center justify-center"
                    onClick={() =>
                        window.open("https://intercom.help/rvr/en", "_blank")
                    }
                >
                    <FaQuestion className="h-6 w-6 text-v3-N-200" />
                </Button>

                {session?.user && !isLoading && (
                    <CreateEventButton
                        user={session.user}
                        communities={communitiesToHost}
                        type="compact"
                        communitySlug={communitySlug as string}
                    />
                )}
            </div>
        </span>
    );
};
